import moment from "moment";

export const getValidationPersonalDetailsDriver = () => {
    return ['firstName', 'lastName', 'fullName', 'identifier', 'city', 'street', 'houseNumber', 'apartmentNumber','mailbox', 'postalCode', 'number', 'emailAddress'];
}

export const getValidationCarAndDriversDetails = () => {
    return ['licenseNumber', 'modelCode', 'vehicleModel', 'carYear', 'identifierMainDriver', 'firstNameYoung', 'lastNameYoung', 'identifierYoung'];
}


export const datePresentation = (date: Date) => {
    if (date != null) {
        return moment(date).format('DD/MM/YYYY');
    }
    return "";
}

export const getEmojiList = () => {
    return [
    '😀',
    '😃',
    '😄',
    '😁',
    '😆',
    '😅',
    '😂',
    '🤣',
    '😭',
    '😉',
    '😗',
    '😙',
    '😚',
    '😘',
    '🥰',
    '😍',
    '🤩',
    '🥳',
    '🫠',
    '🙃',
    '🙂',
    '🥲',
    '🥹',
    '😊',
    '☺️',
    '😌',
    '😏',
    '😴',
    '😪',
    '🤤',
    '😋',
    '😛',
    '😝',
    '😜',
    '🤪',
    '🥴',
    '😔',
    '🥺',
    '😬',
    '😑',
    '😐',
    '😶',
    '😶‍🌫️',
    '🫥',
    '🤐',
    '🫡',
    '🤔',
    '🤫',
    '🫢',
    '🤭',
    '🥱',
    '🤗',
    '🫣',
    '😱',
    '🤨',
    '🧐',
    '😒',
    '🙄',
    '😮‍💨',
    '😤',
    '😠',
    '😡',
    '🤬',
    '😞',
    '😓',
    '😟',
    '😥',
    '😢',
    '☹️',
    '🙁',
    '🫤',
    '😕',
    '😰',
    '😨',
    '😧',
    '😦',
    '😮',
    '😯',
    '😲',
    '😳',
    '🤯',
    '😖',
    '😣',
    '😩',
    '😫',
    '😵',
    '😵‍💫',
    '🫨',
    '🥶',
    '🥵',
    '🤢',
    '🤮',
    '🤧',
    '🤒',
    '🤕',
    '😷',
    '🤥',
    '😇',
    '🤠',
    '🤑',
    '🤓',
    '😎',
    '🥸',
    '🤡',
    '😈',
    '👿',
    '💪',
    '👏',
    '👍',
    '👎',
    '🫶',
    '🙌',
    '👐',
    '🤲',
    '🤝',
    '🤜',
    '🤛',
    '✊',
    '👊',
    '🫳',
    '🫴',
    '🫱',
    '🫲',
    '🫸',
    '🫷',
    '👋',
    '🤚',
    '🖐️',
    '✋',
    '🖖',
    '🤟',
    '🤘',
    '✌️',
    '🤞',
    '🫰',
    '🤙',
    '🤌',
    '🤏',
    '👌',
    '🫵',
    '👉',
    '👈',
    '☝️',
    '👆',
    '👇',
    '✍️',
    '🤳',
    '🙏',
    '❤️',
    '🧡',
    '💛',
    '💚',
    '💙',
    '💜',
    '🤎',
    '🖤',
    '🤍'];
}

